export const CountUp = {
  template: `<span>{{ shown }}</span>`,
  props: {
    value: { type: Number, default: 0 },
    duration: { type: Number, default: 450 },
  },
  data() {
    return {
      shown: this.value,
    };
  },
  created() {
    this.frame = null;
  },
  watch: {
    value(to) {
      cancelAnimationFrame(this.frame);
      const from = this.shown;
      if (from === to || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.shown = to;
        return;
      }
      const start = performance.now();
      const step = (now) => {
        const progress = Math.min(1, Math.max(0, now - start) / this.duration);
        this.shown = Math.round(from + (to - from) * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) this.frame = requestAnimationFrame(step);
      };
      this.frame = requestAnimationFrame(step);
    },
  },
  beforeDestroy() {
    cancelAnimationFrame(this.frame);
  },
};
